import React from 'react'

const Divider = () => {
  return (
        <div className="h-px bg-gray-100 dark:bg-gray-700" /> 
  )
}

export default Divider
